import DietData from "../data/DietData";
import WorkoutData from "../data/WorkoutData";
const get_workout_details = ({ workout }) => {
    const list = WorkoutData.filter((item) => {
        return item.name === workout;
    });
    return list;
};

const get_diet_details = ({ diet }) => {
    const list = DietData.filter((item) => {
        return item.name === diet;
    });
    return list;
};
const get_current_time = () => {
    const date = new Date();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours}:${minutes < 10 ? "0" + minutes : minutes}`;
};

export { get_diet_details, get_current_time, get_workout_details };
